import React from 'react'
import { Modal, TextContainer, TextField, Button, Heading, Card, Badge } from "@shopify/polaris"

class ChangelogModal extends React.Component {

  render() {
    let {
      showChangelogModal,
      toggleChangelogModal,
      ...rest
    } = this.props;

    const SectionTitle = ({title, badge, status}) => {
      return (
        <div style={{display: 'flex'}}>
          <Heading>{title}&nbsp;&nbsp;</Heading>
          <Badge status={status}>{badge}</Badge>
        </div>
      );
    }

    return (
      <Modal
        open={showChangelogModal}
        onClose={toggleChangelogModal}
        title="What's new"
      >
        <Modal.Section>
          <TextContainer>
            <p>
              Find out about all new & upcoming updates to our app here.
            </p>
          </TextContainer>
          <br />
          <Card>
            <Card.Section title={
                <div style={{display: 'flex'}}>
                  <SectionTitle title="TOTAL ORDER WEIGHT" badge="new" status="success" />
                  <Badge status="success">July 2021</Badge>
                </div>
              }>
              <div>
                You can now choose to show the Total Order Weight on your invoices.
                <br />
                Go to Design Invoice &gt; Invoice Details &gt; Tick/Untick ‘Total weight’ &gt; Save
                <br />
                This will reflect on all the documents.
                <br />
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="PRODUCT ITEM NAME" badge="new" status="success" />}>
              <div>
                You can now choose to enable/disable the Product Item Name.
                <br />
                Go to Design Invoice &gt; Product Details &gt; Tick/Untick ‘Product item name’ and Save the Changes.
                <br />
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="EDIT STORE ADDRESS" badge="new" status="success" />}>
              <div>
                The app now allows you to edit the Store address in individual invoices.
                <br />
                If you’d like to change the store address for a particular invoice, go to the invoice &gt; click on ‘Edit’ &gt; Edit Supplier Address &gt; Save &gt; View Document.
                <br />
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="DISABLE SENDING INVOICES TO SPECIFIC CUSTOMERS" badge="new" status="success" />}>
              <div>
                Invoice Falcon now allows setting customer tags to whom the invoices should <strong>NOT</strong> get sent.
                <br />
                To use this setting, please go to Automatic Invoices &gt; Advanced tab and enable the Automatic Invoices settings. Here, under Customer Tags, enter the tags that you do not want to send invoices to and Save. Make sure your customer tags are added to the customers in your Shopify store.
                <br />
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="ARCHIVE INVOICES NOT LINKED TO SHOPIFY ORDERS" badge="new" status="success" />}>
              <div>
                You can temporarily delete invoices created in the app that are not linked to a Shopify order.
                <br />
                Go to the Invoices tab &gt; click on ‘Filter Invoices’ &gt; click on ‘Not linked to Shopify order’ open the invoice you want to delete &gt; click on More &gt; Here, you can either delete the invoice permanently or delete it temporarily by clicking on ‘Delete’.
                <br />
                To restore this invoice, you can go to Invoice &gt; click on ‘Filter Invoices’ &gt; Trashed Invoices &gt; And regenerate an invoice by clicking on the Document No.
                <br />
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="ENABLE MORE TITLES ON PACKING SLIPS" badge="new" status="success" />}>
              <div>
                Packing Slips now allow to enable/disable the Invoice Issue Date, Order Status, Bill To Address and Footer Message.
                <br />
                To make changes, go to Design Invoice &gt; Scroll to the bottom and click on Packing Slip &gt; Make required changes &gt; Save
                <br />
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="CSV EXPORTS" badge="new" status="success" />}>
              <div>
                The csv files will now also pick the SKU and HS code for products and share the tax-break up in separate columns.
                <br />
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="SKU" badge="new" status="success" />}>
              <div>
                The SKU field is now highlighted on the invoices.
                <br />
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={
                <div style={{display: 'flex'}}>
                  <SectionTitle title="SECURITY UPDATE: Code for Automatic Invoices" badge="live" status="success" />
                  <Badge status="success">Feb 2021</Badge>
                </div>
              }>
              <div>
                For Security reasons we have updated the code for Automatic Invoices (basic) and made it more secure.
                <br />
                Merchant's using basic code for Automatic Invoices need to update the code in their Shopify store to continue using this feature. Please follow the steps mentioned in basic section of Automatic Invoices and update the code accordingly in your Shopify store.
                <br />
                <br />
                If you do have any questions about these changes, please let us know at invoicefalcon.shopify@gmail.com.
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="Export to CSV" badge="live" status="success" />}>
              <div>
                Export to CSV is now live! To export your orders/invoices to CSV, please follow these steps -
                <br />
                <br />
                1. Click on '+New Invoice from Shopify order' in the 'Invoices' page.
                <br />
                2. Use the date & status filters provided at the top of the page to filter the orders, or individually select the orders in the list, that you want to export to CSV.
                <br />
                3. Click 'Export to CSV'
                <br />
                4. CSV will be sent to the 'From' address specified in the 'Email Settings' page in a few minutes.
                <br />
                <br />
                <i>Please note that this feature is available only on Plus, Superhero & Ultimate plans.</i>
                <br />
                <br />
                We're always looking for feedback! If you do have any about these changes, please let us know at invoicefalcon.shopify@gmail.com.
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="New settings" badge="live" status="success" />}>
              <div>
                1. You can now show the invoice number in the packing slip. To enable it, head over to Design Invoice &gt; Packing Slip &gt; Enable the checkbox labelled 'Packing slip'.
                <br />
                <br />
                2. You can use the date of first payment on the invoice as the Issue date. (Default is the date the order was placed). To enable it, head over to Design Invoice &gt; Invoice Number, Date and Copies &gt; Enable the checkbox labelled 'Use date of first payment as Issue date'.
              </div>
            </Card.Section>
          </Card>
          <Card>
            <Card.Section title={<SectionTitle title="Invoices for partial/fully refunded orders" badge="live" status="success" />}>
              <div>
                With Invoice Falcon v2.1, we've completely revamped our invoicing systems to support invoices for partial/fully refunded Shopify orders better.
                <br />
                <br />
                Starting today, your invoices will contain all items, even if they were removed from the order, and you'll now see a Refunds subtotal if the order has been adjusted such that you need to refund your customer. For items that are no longer in the order, you'll see a "Refunded" label next to them.
                <br />
                <br />
                We're always looking for feedback! If you do have any about these changes, please let us know.
              </div>
            </Card.Section>
          </Card>
        </Modal.Section>
      </Modal>
    );
  }
}

export default ChangelogModal
